import { render, staticRenderFns } from "./DocumentTopBarButtons.vue?vue&type=template&id=08acafcc&scoped=true&"
import script from "./DocumentTopBarButtons.vue?vue&type=script&lang=js&"
export * from "./DocumentTopBarButtons.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_top_bar.scss?vue&type=style&index=0&id=08acafcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acafcc",
  null
  
)

export default component.exports